import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EmailVerificationComponent } from './components/email-verification/email-verification.component';
import { AboutBodyComponent } from './components/landing/about-body/about-body.component';
import { AnnouncementsComponent } from './components/landing/bulletin-body/announcements/announcements.component';
import { UpcomingComponent } from './components/landing/bulletin-body/upcoming/upcoming.component';
import { ContactBodyComponent } from './components/landing/contact-body/contact-body.component';
import { DirectoryBodyComponent } from './components/landing/directory-body/directory-body.component';
import { DownloadBodyComponent } from './components/landing/download-body/download-body.component';
import { FAQBodyComponent } from './components/landing/faqbody/faqbody.component';
import { GuidelineBodyComponent } from './components/landing/guideline-body/guideline-body.component';
import { HomeComponent } from './components/landing/home/home.component';
import { LandingComponent } from './components/landing/landing.component';
import { LoginComponent } from './components/login/login.component';
import { RequestResetComponent } from './components/password/request-reset/request-reset.component';
import { ResponseResetComponent } from './components/password/response-reset/response-reset.component';
import { RegisterComponent } from './components/register/register.component';
import { StudentRegisterComponent } from './components/student-register/student-register.component';
import { NotFoundComponent } from './pages/errors/not-found/not-found.component';
import { BeforeLoginService } from './Services/before-login.service';
import { ImageGalleryComponent } from './components/landing/image-gallery/image-gallery.component';
import { VideoGalleryComponent } from './components/landing/video-gallery/video-gallery.component';
import { LeadershipTeamComponent } from './components/landing/leadership-team/leadership-team.component';
import { MessagesComponent } from './components/landing/messages/messages.component';
import { InstituteRegisterComponent } from './components/institute-register/institute-register.component';
import { FacultyRegisterComponent } from './components/faculty-register/faculty-register.component';
import { EmailComponent } from './components/email/email.component';
import { AfterLoginService } from './Services/after-login.service';
import { HodRegisterComponent } from './components/hod-register/hod-register.component';
import { TemporaryDashboardComponent } from './temporary-dashboard/temporary-dashboard.component';
import { AdminSpecializationComponent } from './components/users/admin/admin-specialization/admin-specialization.component';
import { InstituteDashboardComponent } from './temporary-dashboard/institute-dashboard/institute-dashboard.component';
import { StudentSelfRegisterComponent } from './components/student-self-register/student-self-register.component';
import { UnderMaintenanceComponent } from './pages/errors/under-maintenance/under-maintenance.component';
import { GrievanceComponent } from './components/grievance/grievance.component';
import { GrievanceTableComponent } from './components/grievance-table/grievance-table.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { InstituteDetailsComponent } from './components/institute-details/institute-details.component';
import { RequestResetOtpComponent } from './components/password/request-reset-otp/request-reset-otp.component';

const appRoutes: Routes = [
  // {
  //   path: 'dashboard',
  //   component: TemporaryDashboardComponent,
  // },
  {
    path: 'dashboard/institute-dashboard',
    component: InstituteDashboardComponent,
  },
  {
    path: '',
    component: LandingComponent,
    children: [
      {
        path: '',
        component: HomeComponent,
      },
      {
        path: 'aboutus',
        component: AboutBodyComponent,
      },
      {
        path: 'directory',
        component: DirectoryBodyComponent,
      },
      {
        path: 'guidelines',
        component: GuidelineBodyComponent,
      },
      {
        path: 'downloads',
        component: DownloadBodyComponent,
      },
      {
        path: 'faq',
        component: FAQBodyComponent,
      },
      {
        path: 'contactus',
        component: ContactBodyComponent,
      },
      {
        path: 'bulletin',
        component: AnnouncementsComponent,
      },
      {
        path: 'bulletin/upcoming',
        component: UpcomingComponent,
      },
      {
        path: 'bulletin/announcements',
        component: AnnouncementsComponent,
      },
      {
        path: 'image-gallery',
        component: ImageGalleryComponent,
      },
      {
        path: 'video-gallery',
        component: VideoGalleryComponent,
      },
      {
        path: 'leadership-team',
        component: LeadershipTeamComponent,
      },
      {
        path: 'messages',
        component: MessagesComponent,
      },
      {
        path: 'email',
        component: EmailComponent,
      },
      {
        path: 'specialization',
        component: AdminSpecializationComponent,
      },
      {
        path: 'under-maintenance',
        component: UnderMaintenanceComponent,
      },
      {
        path: 'institute-details',
        component: InstituteDetailsComponent,
      },

    ],
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [BeforeLoginService],
  },
  {
    path: 'register',
    component: RegisterComponent,
  },
  {
    path: 'student-register',
    component: StudentRegisterComponent,
    canActivate: [BeforeLoginService],
  },
  {
    path: 'student-self-register',
    component: StudentSelfRegisterComponent,
    canActivate: [BeforeLoginService],
  },
  {
    path: 'institute-register',
    component: InstituteRegisterComponent,
    canActivate: [BeforeLoginService],
  },
  {
    path: 'faculty-register',
    component: FacultyRegisterComponent,
    canActivate: [BeforeLoginService],
  },
  // {
  //   path: 'hod-register',
  //   component: HodRegisterComponent,
  //   canActivate: [BeforeLoginService],
  // },
  {
    path: 'verify-email',
    component: EmailVerificationComponent,
    canActivate: [BeforeLoginService],
  },
  {
    path: 'request-password-reset',
    component: RequestResetComponent,
    canActivate: [BeforeLoginService],
  },
  {
    path: 'request-password-reset-otp',
    component: RequestResetOtpComponent,
    canActivate: [BeforeLoginService],
  },
  {
    path: 'response-password-reset',
    component: ResponseResetComponent,
    canActivate: [BeforeLoginService],
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent,
    canActivate: [AfterLoginService]
  },
  {
    path: 'admin',
    loadChildren: () =>
      import('./components/users/admin/admin.module').then(
        (m) => m.AdminModule
      ),
    canActivate: [AfterLoginService],
  },
  {
    path: 'expert',
    loadChildren: () =>
      import('./components/users/expert/expert.module').then(
        (m) => m.ExpertModule
      ),
    canActivate: [AfterLoginService],
  },
  // {
  //   path: 'hod',
  //   loadChildren: () =>
  //     import('./components/users/hod/hod.module').then((m) => m.HodModule),
  //   canActivate: [AfterLoginService],
  // },
  {
    path: 'institute',
    loadChildren: () =>
      import('./components/users/institute/institute.module').then(
        (m) => m.InstituteModule
      ),
    canActivate: [AfterLoginService],
  },
  {
    path: 'moderator',
    loadChildren: () =>
      import('./components/users/moderator/moderator.module').then(
        (m) => m.ModeratorModule
      ),
    canActivate: [AfterLoginService],
  },
  {
    path: 'student',
    loadChildren: () =>
      import('./components/users/student/student.module').then(
        (m) => m.StudentModule
      ),
    canActivate: [AfterLoginService],
  },
  {
    path: 'faculty',
    loadChildren: () =>
      import('./components/users/faculty/faculty.module').then(
        (m) => m.FacultyModule
      ),
    canActivate: [AfterLoginService],
  },
  {
    path: 'finance',
    loadChildren: () =>
      import('./components/users/finance/finance.module').then(
        (m) => m.FinanceModule
      ),
    canActivate: [AfterLoginService],
  },
  {
    path: 'consultant',
    loadChildren: () =>
      import('./components/users/consultant/consultant.module').then(
        (m) => m.ConsultantModule
      ),
    canActivate: [AfterLoginService],
  },
  {
    path: 'specialization',
    component: AdminSpecializationComponent,
  },
  {
    path: 'grievance',
    component: GrievanceComponent,
    canActivate: [AfterLoginService]
  },
  {
    path: 'grievanceTable',
    component: GrievanceTableComponent,
    canActivate: [AfterLoginService]
  },
  {
    path: '**',
    component: NotFoundComponent,
  },
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forRoot(appRoutes)],
})
export class AppRoutingModule {}
